import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-012bd59a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-box",
  method: "dialog"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Modifier un utilisateur", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "modal-action" }

import { ref, onMounted, toRef } from "vue";
import {
    getUsersNotLinkedToBackOfficeSupplier,
    addExistingUserToBackOfficeList,
    IUserListToForDropdown,
    IUpdateBackOfficeUserList
} from "@/_services/supplier/backOfficeSupplier/backofficeSupplier";
import swal from "@/_helpers/swal";

const requiredLengthToAutoComplete: number = 3 as number;

export default /*#__PURE__*/_defineComponent({
  __name: 'backOfficeUserCreateFormModal',
  props: {
    supplierUuid: {
        type: String,
        required: false,
        default: "",
    },
    addBackOfficeUserFormModalid: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props;


const addBackOfficeUserFormModalid = toRef(props, "addBackOfficeUserFormModalid");
const modalHTMLElement = ref<HTMLDialogElement | null>(null);
const supplierUuid = toRef(props, "supplierUuid");
const selectedUser = ref<string | null>(null);

async function setUsersListForDropdown({ search }) {
    if (!search) return [];
    if (search.length >= requiredLengthToAutoComplete) {
        // Iterating over results to set the required `label` and `value` keys.
        const response = await getUsersNotLinkedToBackOfficeSupplier(search, supplierUuid.value);
        return response.map((result: IUserListToForDropdown) => {
            return {
                label: result.fullname,
                value: result.uuid
            }
        })
    }
    return []; // If the request fails, we return an empty array.
}


const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.attributeName === "open" && modalHTMLElement.value) {
            const isOpen = modalHTMLElement.value.open;
            const isclosed = !isOpen;
            if (isclosed) {
                selectedUser.value = null;
            }
            break; // Exit the loop once the class attribute has been processed
        }
    }
});

onMounted(() => {
    modalHTMLElement.value = document.querySelector(
        `#${addBackOfficeUserFormModalid.value}`
    );
    if (modalHTMLElement.value) {
        observer.observe(modalHTMLElement.value, { attributes: true });
    }
});

const submitHandler = async (formData, formNode) => {
    try {
        closeModalDialog();
        const backOfficeUserUuid = formData.backOfficeUser;
        const data: IUpdateBackOfficeUserList = {
            user: `api/users/${backOfficeUserUuid}`,
            supplier: `api/suppliers/${supplierUuid.value}`
        };
        await swal
            .confirm("Êtes-vous sûr de vouloir rajouter cet utilisateur au back office de ce fournisseur ?",
                "Annuler",
                "Oui"
            )
            .then((results) => results.isConfirmed && addUserToBackOfficeList(data));
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
};

const addUserToBackOfficeList = (data: IUpdateBackOfficeUserList) => {
    addExistingUserToBackOfficeList(data);
};

const closeModalDialog = () => {
    if (modalHTMLElement.value) {
        modalHTMLElement.value.close();
    }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("dialog", {
    ref: "HTMLDialogElement",
    id: addBackOfficeUserFormModalid.value,
    class: "modal modal-middle sm:modal-middle"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormKit, {
        type: "form",
        id: "addBackOfficeUserForm",
        onSubmit: submitHandler,
        actions: false,
        "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement."
      }, {
        default: _withCtx(({ state: { valid } }) => [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_FormKit, {
            modelValue: selectedUser.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUser).value = $event)),
            name: "backOfficeUser",
            type: "autocomplete",
            label: "Utilisateur",
            placeholder: "Choisissez un utilisateur",
            help: "Veuillez renseignez au minimum 3 lettres",
            "selection-appearance": "option",
            "empty-message": "Aucun résultat",
            validation: "required",
            "validation-visibility": "dirty",
            "validation-messages": { required: 'Ce champs est requis.' },
            options: setUsersListForDropdown
          }, null, 8, ["modelValue", "validation-messages"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (closeModalDialog()))
            }, "Annuler"),
            _createVNode(_component_FormKit, {
              type: "submit",
              label: "Modifier",
              disabled: !valid
            }, null, 8, ["disabled"])
          ])
        ]),
        _: 1
      })
    ])
  ], 8, _hoisted_1))
}
}

})